module.exports = __webpack_public_path__ + "static/img/100823.983cef78.png";